import {
  VOID3gxj6tk5isa35 as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class KrpcSerialFormatBuilder {
  constructor(rpcSerialFormat, from, builder) {
    from = from === VOID ? null : from;
    var tmp = this;
    tmp.n8l_1 = KrpcSerialFormatBuilder$builder$lambda(rpcSerialFormat, from, builder);
  }
  j7e() {
    return this.n8l_1(null);
  }
  o8l(serializersModule) {
    return this.n8l_1(serializersModule);
  }
}
class String_0 extends KrpcSerialFormatBuilder {
  constructor(rpcSerialFormat, from, builder) {
    from = from === VOID ? null : from;
    super(rpcSerialFormat, from, builder);
  }
}
//endregion
function KrpcSerialFormatBuilder$builder$lambda$lambda($builder, $serializersModule, $$this$with) {
  return ($this$withBuilder) => {
    $builder($this$withBuilder);
    var tmp0_safe_receiver = $serializersModule;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $$this$with.p8l($this$withBuilder, tmp0_safe_receiver);
    }
    return Unit_instance;
  };
}
function KrpcSerialFormatBuilder$builder$lambda($rpcSerialFormat, $from, $builder) {
  return (serializersModule) => {
    // Inline function 'kotlin.with' call
    var $this$with = $rpcSerialFormat;
    return $this$with.q8l($from, KrpcSerialFormatBuilder$builder$lambda$lambda($builder, serializersModule, $this$with));
  };
}
//region block: post-declaration
initMetadataForClass(KrpcSerialFormatBuilder, 'KrpcSerialFormatBuilder');
initMetadataForClass(String_0, 'String');
//endregion
//region block: exports
export {
  String_0 as String25daxfxml2302,
};
//endregion
